import _ from 'underscore';

import Evaluation from 'pages/open-course/assessment/models/exam/evaluation';

const SubmissionPartEvaluation = Evaluation.extend({
  defaults: _({}).extend(Evaluation.prototype.defaults, {
    partId: null,
  }),
});

export default SubmissionPartEvaluation;
